// extracted by mini-css-extract-plugin
export default {"orders":"feed-stats_orders__UQnHG","orders__board":"feed-stats_orders__board__S+6Wp","list":"feed-stats_list__c0rdj","list_green":"feed-stats_list_green__tupSU"};